import React from "react";
import { useNavigate } from "react-router-dom";
import "./ServicesCTA.css";

const ServicesCTA = () => {
  const navigate = useNavigate();
  return (
    <section className="services-cta">
      <h2>Ready to Start Your Project?</h2>
      <p>
        Let’s discuss how technology can simplify and grow your jewellery
        business.
      </p>
      <button
        onClick={() => {
          navigate("/contact-us");
          window.scrollTo({ top: 0 });
        }}
      >
        Contact Us
      </button>
    </section>
  );
};

export default ServicesCTA;
